import { http } from "@/configurations/axios";
import { unpackCatalogEnvelope } from "../catalogoDigitalConfig";

function dataFrom(response) {
  return unpackCatalogEnvelope(response && response.data);
}

function withCacheBuster(params = {}) {
  return {
    ...params,
    _t: Date.now(),
  };
}

export function getCatalogConfiguration() {
  return http
    .get("/catalogo-digital/configuracao", {
      params: withCacheBuster(),
    })
    .then(dataFrom);
}

export function saveCatalogConfiguration(payload) {
  return http
    .post("/catalogo-digital/configuracao", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then(dataFrom);
}

export function getCatalogProducts() {
  return http
    .get("/catalogo-digital/produtos", {
      params: withCacheBuster(),
    })
    .then(dataFrom);
}

export function getCatalogManagementProducts(params = {}) {
  return http
    .get("/catalogo-digital/produtos/gestao", {
      params: withCacheBuster({
        page: params.page || 1,
        per_page: params.per_page || 12,
        busca: params.busca || "",
        publicado: params.publicado || "todos",
      }),
    })
    .then(dataFrom);
}

export function publishCatalogProducts(payload) {
  return http
    .post("/catalogo-digital/produtos/publicar", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then(dataFrom);
}

export function getCatalogPromotions() {
  return http
    .get("/catalogo-digital/promocoes", {
      params: withCacheBuster(),
    })
    .then(dataFrom);
}

export function saveCatalogPromotion(payload) {
  return http.post("/catalogo-digital/promocoes", payload).then(dataFrom);
}

export function deleteCatalogPromotion(id) {
  return http
    .delete(`/catalogo-digital/promocoes/${encodeURIComponent(id)}`)
    .then(dataFrom);
}
